import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';
import ReactPlayer from 'react-player';

import ContentContainer from '../Common/ContentContainer';
import { PrimaryLink } from '../Common/Links';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import HeadingCtas from './HeadingCtas';
import * as styles from './OverlappingHero.module.css';

const OverlappingHero = ({ hero, copy, heading, ctaLabel, ctaOnClick, ctas, center, videoUrl, fullBleed }) => {
  return (
    <ContentContainer
      wide
      isTopSection
      className={[styles.padAdjust, center ? styles.noPad : '', fullBleed ? styles.bleed : ''].join(' ')}
    >
      <div className={[styles.grid, center ? styles.center : '', styles.wrap].join(' ')}>
        <div className={styles.copy}>
          <h1>{heading}</h1>
          <RichTextConverter copy={copy} className={styles.paragraph} />
          {!ctas && <PrimaryLink isButton label={ctaLabel} onClick={ctaOnClick} />}
          {ctas && <HeadingCtas ctas={ctas} />}
        </div>
        {!videoUrl && (
          <div className={styles.hero}>
            <img src={get(hero, 'file.url')} alt={hero?.title || ''} className={styles.heroImage} />
          </div>
        )}
        {videoUrl && (
          <div className={styles.grey}>
            <div className={styles.videoAdjust}>
              <div className={styles.wistiaWrap}>
                <div className={`wistia-wrapper-${videoUrl}`}>
                  <ReactPlayer
                    controls={true}
                    className={`wistia-react-player-${videoUrl}`}
                    width={'100%'}
                    height="100%"
                    url={videoUrl}
                    config={{
                      wistia: {
                        options: {
                          smallPlayButton: true,
                        },
                      },
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </ContentContainer>
  );
};

OverlappingHero.propTypes = {
  hero: PropTypes.object,
  copy: PropTypes.object,
  heading: PropTypes.string,
  ctaLabel: PropTypes.string,
  ctaOnClick: PropTypes.func,
};

export default OverlappingHero;
